// extracted by mini-css-extract-plugin
export default {"padding_lg":"car-type_padding_lg__0BL-3","wrap":"car-type_wrap__8l0Gd"};